import { defineStore } from "pinia";
import { useInstitutionComposable } from "./institution";
import { useGroupComposable } from "./group";
import { useRelationsComposable } from "./relations";
import { useConfidentialFolderComposable } from "./confidentialFolder";
import { usePeopleComposable } from "./people";

export const usePeopleStore = defineStore("people", () => {
  const institution = useInstitutionComposable();
  const group = useGroupComposable();
  const relations = useRelationsComposable();
  const confidentialFolder = useConfidentialFolderComposable();
  const people = usePeopleComposable();

  return {
    ...institution,
    ...relations,
    ...confidentialFolder,
    ...people,
    ...group
  };
});
